<template>
  <v-app id="inspire">
    <v-toolbar
      color="teal accent-4"
      dark
      app
      tabs
      scroll-off-screen
    >
      <v-avatar size="56">
        <img src="./assets/logo.png">
      </v-avatar>
      <v-toolbar-title class="font-weight-light font-italic pr-1">жизнь - складывается!</v-toolbar-title>
      <v-tabs
        slot="extension"
        v-model="tabModel"
        centered
        color="teal accent-4"
        slider-color="yellow"
      >
        <v-tab
          v-for="(mode, i) in rezhim"
          :key="i"
          :href="`#tab-${i}`"
        >
          {{ mode }}
        </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-content>

      <v-tabs-items v-model="tabModel">
        <v-tab-item transition="fade-transition" value="tab-0">
          <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
              <v-switch label="Задать позиции" v-model="cardsPositions" color="primary"></v-switch>
              <v-switch label="Зеркальная цепочка" v-model="mirror" color="primary"></v-switch>
              <v-switch label="Задать обозначения" v-model="uniqCards" color="primary"></v-switch>
            </v-layout>
            <v-layout row wrap justify-center v-show="uniqCards" transition="fade-transition">
              <v-flex xs12 sm6 lg2>
                <v-text-field v-model="nominalyStr" validate-on-blur label="Номиналы"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 lg2>
                <v-text-field v-model="mastiStr" validate-on-blur label="Масти">Масти
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap row v-show="cardsPositions" transition="fade-transition">
              <v-flex xs4 sm3 md2 lg1 v-for="(s, i) in selectedCards" :key="i">
                <v-select
                  outline
                  hide-details
                  hide-selected
                  :items="filterItems(i)"
                  v-model="selectedCards[i]"
                  :label="i + 1 + ':'"
                  no-data-text="Свободные карты закончились"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-1">
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <span class="title">Формула:</span>
                <v-radio-group row v-model="formulaNum" hide-details>
                  <v-radio label="34:1:1" value="34" color="primary"></v-radio>
                  <v-radio label="35:1" value="35" color="primary"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 class="mt-3">
                <span class="title">Целевая карта:</span>
                <v-radio-group row v-model="checkedCard" hide-details>
                  <v-radio v-for="(card, idx) in mainCard" :key="idx" :label="card" :value="card"
                           color="primary" class="mb-2"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-container grid-list-xl>
            <v-layout justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-datetime-picker
                  locale="ru-RU"
                  clearText="Отменить"
                  format="DD.MM.YYYY HH:mm:ss"
                  label="Время для целевой карты"
                  v-model="timingDate"
                >
                </v-datetime-picker>
                <v-text-field v-model="intervalsStr" validate-on-blur label="Интервалы" class="mt-4">Интервалы
                </v-text-field>
                <v-subheader class="pl-0 mt-3">Номер целевой карты</v-subheader>
                <v-slider
                  v-model="cardFor"
                  prepend-icon="remove"
                  @click:prepend="cardFor--"
                  append-icon="add"
                  @click:append="cardFor++"
                  thumb-label="always"
                  always-dirty
                  hide-details
                  :thumb-size="28"
                  min="1"
                  max="40"
                ></v-slider>
                <v-subheader class="pl-0 mt-3">Коэффициент</v-subheader>
                <v-slider
                  v-model="coeff"
                  thumb-label="always"
                  prepend-icon="remove"
                  @click:prepend="coeff--"
                  append-icon="add"
                  @click:append="coeff++"
                  hide-details
                  :thumb-size="28"
                  always-dirty
                  min="1"
                ></v-slider>
              </v-flex>

            </v-layout>
          </v-container>
        </v-tab-item>
      </v-tabs-items>

      <v-container>
        <v-layout justify-center>
          <v-flex xs12>
            <v-text-field
              outline
              placeholder="найденная цепочка отобразится здесь"
              @click:append-outer="doCopy"
              single-line
              prepend-inner-icon="fas fa-link"
              append-outer-icon="far fa-copy"
              v-model="stringChain"
            ></v-text-field>
          </v-flex>
        </v-layout>
          <v-layout justify-center>
          <v-flex xs12 sm6 md4 lg3>
            <v-btn
              block
              large
              :loading="loading"
              color="teal lighten-2"
              dark
              @click="mainEvent"
            >
              {{ mainBtnText }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container v-show="tabModel != 'tab-2'">
        <v-layout row wrap justify-center>
          <v-flex xs12>
                <v-alert v-for="(item, index) in allChains"
                  :key="index"
                  :value="true"
                  color="info"
                  icon="fas fa-link"
                  outline
                  transition="fade-transition"
                >{{ item }}</v-alert>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container id="timing" v-show="(timing.length > 0) && (tabModel === 'tab-2')">
        <v-layout row wrap justify-center>
          <v-flex xs12 sm8>
            <v-list>
              <v-list-tile
                v-for="(item, index) in timing"
                :key="index"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-text="item"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon v-if="index === cardFor-1" color="pink">pets</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  <!--      <v-footer color="teal accent-4" dark app height="auto">
          <v-spacer></v-spacer>
          <v-btn icon href="http://t.me/MagicDecksBot">
            <v-icon medium>fab fa-telegram</v-icon>
          </v-btn>
          <span class="mr-4">- тут за правильный расклад</span>
        </v-footer>-->
    <v-snackbar
      v-model="snackbar"
      color="info"
      top
      :timeout="3000"
    >
      {{ snackbarText }}
      <v-btn
        dark
        flat
        @click="snackbar = false"
      >
        Закрыть
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
  export default {
    data: function () {
      return {
        loading: false,
        rezhim: ['Случайноcти', 'Формулы', 'Тайминг'],
        mainCard: ['Тб', 'Тч', 'Тк', 'Тп', 'Дч', '10б', '10ч', '10к'],
        checkedCard: 'Тб',
        snackbar: false,
        uniqCards: false,
        mirror: false,
        timingDate: new Date(),
        timing: [],
        cardsPositions: false,
        formulaNum: '34',
        tabModel: 'tab-0',
        snackbarText: '',
        chainResult: false,
        stringChain: '',
        mastiStr: 'п, ч, к, б',
        nominalyStr: '6, 7, 8, 9, 10, В, Д, К, Т',
        coeff: 1,
        cardFor: 1,
        intervalsStr: '173, 273, 373, 473, 573, 137, 237, 337',
        fullCardNames: {
          '6п': '6 пик',
          '6ч': '6 червей',
          '6к': '6 крестей',
          '6б': '6 бубей',
          '7п': '7 пик',
          '7ч': '7 червей',
          '7к': '7 крестей',
          '7б': '7 бубей',
          '8п': '8 пик',
          '8ч': '8 червей',
          '8к': '8 крестей',
          '8б': '8 бубей',
          '9п': '9 пик',
          '9ч': '9 червей',
          '9к': '9 крестей',
          '9б': '9 бубей',
          '10п': '10 пик',
          '10ч': '10 червей',
          '10к': '10 крестей',
          '10б': '10 бубей',
          'Вп': 'Валет пик',
          'Вч': 'Валет червей',
          'Вк': 'Валет крестей',
          'Вб': 'Валет бубей',
          'Дп': 'Дама пик',
          'Дч': 'Дама червей',
          'Дк': 'Дама крестей',
          'Дб': 'Дама бубей',
          'Кп': 'Король пик',
          'Кч': 'Король червей',
          'Кк': 'Король крестей',
          'Кб': 'Король бубей',
          'Тп': 'Туз пик',
          'Тч': 'Туз червей',
          'Тк': 'Туз крестей',
          'Тб': 'Туз бубей'
        },
        template35: [1, 3, 3, 1, 2, 2, 1, 3, 2, 2, 1, 1, 2, 2, 1, 4, 2, 2, 1, 4, 4, 3, 2, 4, 4, 3, 3, 4, 4, 3, 3, 4, 1, 3, 1, 4],
        template34: [1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 3, 4, 4, 3, 3, 4, 4, 3, 3, 4, 4, 3, 3, 4, 4, 3, 2, 2, 4, 1, 1, 2, 3, 2, 1, 2],
        mastiNomer: {1: '', 2: '', 3: '', 4: ''},
        tempMasti: ['п', 'б', 'к', 'ч'],
        tempNominaly: ['6', '7', '8', '9', '10', 'В', 'Д', 'К', 'Т'],
        fixCard: ['6', '7', '8', '10'],
        allChains: [],
        options: {offset: -50},
        selectedCards: Array(36),
        nominalsPickFrom: [],
        shod: 3
      }
    },
    watch: {
      vsegoCard: function (val) {
        this.selectedCards.length = val
      }
    },
    computed: {
      baseDeck: function () {
        let BaseDeck = []
        for (let n of this.nominaly) {
          for (let m of this.masti) {
            BaseDeck.push(n + m)
          }
        }
        return BaseDeck
      },
      intervals: function () {
        return this.intervalsStr.split(/\s*[\s,]\s*/).filter(Boolean)
      },
      nominaly: function () {
        return this.nominalyStr.split(/\s*[\s,]\s*/).filter(Boolean)
      },
      masti: function () {
        return this.mastiStr.split(/\s*[\s,]\s*/).filter(Boolean)
      },
      vsegoCard: function () {
        return this.masti.length * this.nominaly.length
      },
      mainBtnText: function () {
        if (this.tabModel === 'tab-2') return 'Получить тайминг'
        else return 'Собрать цепочку'
      }
    },
    methods: {
      filterItems (index) {
        return this.baseDeck.filter(n => [ -1, index ].includes(this.selectedCards.indexOf(n)))
      },
      mainEvent: function () {
        if (this.tabModel === 'tab-0') {
          this.loading = !this.loading
          let deckCopyFirst = this.baseDeck.slice()
          let newChainTemplate = this.selectedCards.slice()
          let ch = []
          let cr = []
          let iter = 0
          let timeOut = false
          let x = this.vsegoCard
          let y = this.vsegoCard
          let m = 100000
          if (this.mirror) { m = 2 }
          while (x > 2 || y > m) {
            ch = this.makeRandomChain(deckCopyFirst, newChainTemplate)
            x = this.analyzeChain(ch)
            if (this.mirror) {
              cr = ch.slice().reverse()
              y = this.analyzeChain(cr)
            }
            iter++
            if (iter > 27500) {
              timeOut = true
              break
            }
          }
          if (timeOut) {
            this.snackbarText = 'Такая цепочка не найдена'
            this.snackbar = true
          } else {
            let chString = ch.join(' ')
            this.stringChain = chString
            if (this.mirror) {
              chString = chString + ' | ' + cr.join(' ')
            }
            this.allChains.unshift(chString)
          }
          this.loading = !this.loading
        } else if (this.tabModel === 'tab-1') {
          let testChain = ''
          do {
            this.nominalsPickFrom = this.makeNominalsX4(this.tempNominaly)
            testChain = this.constructMasti(this.checkedCard, this.formulaNum)
          } while (this.shod > 0)
          this.stringChain = testChain
          this.allChains.unshift(this.stringChain)
        } else if (this.tabModel === 'tab-2') {
          if (this.stringChain.length > 0) {
            this.timing.length = 0
            let interval = 0
            let start = this.$moment(this.timingDate)
            for (let i = 0; i < 39; i++) {
              this.timing.push(this.intervals[interval] * this.coeff)
              interval < this.intervals.length - 1 ? interval++ : interval = 0
            }

            let timeFirst = start.format('DD.MM HH:mm:ss')
            this.timing.splice(this.cardFor - 1, 0, timeFirst)

            let timeInterval = ''

            if (this.cardFor < 40) {
              for (let i = this.cardFor - 1; i < 40; i++) {
                timeInterval = start.add(this.timing[i], 'seconds').format('DD.MM HH:mm:ss')
                this.timing.splice(i, 1, timeInterval)
              }
              start = this.$moment(timeFirst, 'DD.MM HH:mm:ss')
            }

            if (this.cardFor > 1) {
              for (let i = this.cardFor - 2; i > -1; i--) {
                timeInterval = start.subtract(this.timing[i], 'seconds').format('DD.MM HH:mm:ss')
                this.timing.splice(i, 1, timeInterval)
              }
            }
            let fullCard = ''
            let chain = this.stringChain.replace(/X|Х/ug, '10').split(' ')
            for (let num = 0; num < this.timing.length; num++) {
              if (num === 0 || num === 39) fullCard = 'Пустышка'
              else if (num === 1) fullCard = 'Открывающая карта'
              else if (num === 38) fullCard = 'Закрывающая карта'
              else fullCard = this.fullCardNames[chain[num - 2]]
              this.timing[num] = `${num + 1}: ${this.timing[num]} - ${fullCard}`
            }
            this.$copyText(this.timing.join('\n'))
            this.snackbarText = 'Тайминг скопирован'
            this.snackbar = true
            this.$scrollTo('#timing', 500, this.options)
          } else {
            this.snackbarText = 'Добавьте цепочку'
            this.snackbar = true
          }
        }
      },
      doCopy: function () {
        this.$copyText(this.stringChain)
        this.snackbarText = 'Цепочка скопирована в буфер обмена'
        this.snackbar = true
      },
      get_random: function (arr) {
        return arr[Math.floor((Math.random() * arr.length))]
      },
      shuffle: function (arr) {
        for (let i = arr.length; i > 0; --i) { arr.push(arr.splice(Math.random() * i | 0, 1)[0]) }
        return arr
      },
      makeNominalsX4: function (arr) {
        let nominalsX4 = []
        for (let n = 0; n < 9; n++) {
          for (let i = 0; i < 4; i++) {
            nominalsX4.push(arr[n])
          }
        }
        return nominalsX4
      },
      pick: function (arr, i) {
        return arr.splice(i >= 0 ? i : Math.random() * arr.length | 0, 1)[0]
      },
      constructMasti: function (card, template) {
        let mast1 = card.slice(-1)
        let ended = this.fixCard.slice()
        let nominal1 = card.slice(0, -1)
        if (nominal1 === '10') {
          ended.splice(-1, 1)
        }
        let tnominals = this.tempNominaly.slice()
        this.mastiNomer[1] = mast1
        let j = this.shuffle(this.tempMasti).indexOf(mast1)
        for (let z = 2; z < 5; z++) {
          j >= 3 ? j = 0 : j++
          this.mastiNomer[z] = this.tempMasti[j]
        }
        let stringTemplate = ''
        if (template === '34') stringTemplate = this.template34.join('')
        else if (template === '35') stringTemplate = this.template35.join('')
        stringTemplate = stringTemplate.replace(/1/g, this.mastiNomer[1]).replace(/2/g, this.mastiNomer[2]).replace(/3/g, this.mastiNomer[3]).replace(/4/g, this.mastiNomer[4]).split('')
        stringTemplate[34] = card
        this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1))
        this.pick(tnominals, tnominals.indexOf(nominal1))
        stringTemplate[0] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf('В')) + stringTemplate[0]
        stringTemplate[1] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf('9')) + stringTemplate[1]
        stringTemplate[2] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf('Т')) + stringTemplate[2]

        if (template === '34') {
          stringTemplate[28] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[28]
          stringTemplate[32] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[32]
          nominal1 = this.get_random(ended)
          this.pick(tnominals, tnominals.indexOf(nominal1))
          this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1))
          stringTemplate[35] = nominal1 + stringTemplate[35]
          this.pick(tnominals, tnominals.indexOf('9'))
          this.pick(tnominals, tnominals.indexOf('В'))
          if (!~tnominals.indexOf('Т')) {
            this.pick(tnominals, tnominals.indexOf('Т'))
          }
          nominal1 = this.get_random(tnominals)
          stringTemplate[8] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[8]
          stringTemplate[19] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[19]
          stringTemplate[25] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[25]
          stringTemplate[33] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[33]
        } else if (template === '35') {
          stringTemplate[31] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[31]
          nominal1 = this.get_random(ended)
          this.pick(tnominals, tnominals.indexOf(nominal1))
          stringTemplate[33] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[33]
          stringTemplate[35] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[35]
          nominal1 = this.get_random(tnominals)
          stringTemplate[15] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[15]
          stringTemplate[22] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[22]
          stringTemplate[29] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[29]
        }
        for (let i = 2; i < 34; i++) {
          if (stringTemplate[i].length === 1) {
            this.shuffle(this.nominalsPickFrom)
            for (let c = 0; c < this.nominalsPickFrom.length; c++) {
              nominal1 = this.nominalsPickFrom[c]
              if (!~stringTemplate[i - 2].indexOf(nominal1) && !~stringTemplate[i + 2].indexOf(nominal1) && !~stringTemplate.indexOf(nominal1 + stringTemplate[i])) {
                stringTemplate[i] = this.pick(this.nominalsPickFrom, this.nominalsPickFrom.indexOf(nominal1)) + stringTemplate[i]
                break
              }
            }
          }
        }
        this.shod = this.nominalsPickFrom.length
        return stringTemplate.join(' ')
      },
      makeRandomChain: function (deck, newdeck) {
        let randomChain = new Array(this.vsegoCard)
        let deckCopy = deck.filter(f => !newdeck.includes(f))
        for (let i = 0; i < this.vsegoCard; i++) {
          if (newdeck[i] === undefined) {
            randomChain[i] = deckCopy.splice(Math.floor(Math.random() * deckCopy.length), 1).join('')
          } else randomChain[i] = newdeck[i]
        }
        return randomChain
      },
      analyzeChain: function (chain) {
        let chainCopy = chain.slice()
        let test = true
        while (test) {
          if (chainCopy.length === 2) test = false
          for (let i = 1; i < chainCopy.length - 1; i++) {
            if (chainCopy[i - 1][0] === chainCopy[i + 1][0] || chainCopy[i - 1][chainCopy[i - 1].length - 1] === chainCopy[i + 1][chainCopy[i + 1].length - 1]) {
              chainCopy.splice(i - 1, 1)
              break
            }
            if (i === chainCopy.length - 2) test = false
          }
        }
        return chainCopy.length
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue